import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Row, Col, message } from "antd";
import { getTokenTimestamp, scrollToTop } from "../../../Utils";
import { Wrapper, CustomLabel } from "../../../Common/style";
import {
  GET_PPMC_DETAILS,
  GET_TELE_BOOKING_DETAILS,
  GET_TELE_TPA_DETAILS,
  JWT_LOGIN,
  JWT_REFRESH,
} from "../../../Services/endpoints";
import { error_message, getURlParameter } from "../../../Constant";
import { getApi, postApi } from "../../../Services/apiService";
import TeleDetails from "./TeleDetails";
import { PolicyDetails, TeleAppointmentDetails } from "../CommonData";
import { resetBookMemberDetails, setTpaDetails } from "../../../Redux/BookTeleMedical/action";
import { decrypt, encrypt } from "../../../Services/AESEncryptionDecryption";
import { SET_TELE_APPOINTMENT_LOADED } from "../../../Redux/TeleAppointmentDetails/types";
import { arrowBackIcon } from "../../../Assets/Images";
import CONSTANTS from "../../../Utils/constant";
import PAGE_CONSTANTS from "./constant";
import styled from "styled-components";
import "./style.css";
import { setAppointmentDetails } from "../../../Redux/TeleAppointmentDetails/action";
import { getPolicyDetails } from "../../../Redux/PolicyNumber/action";
import { SET_APP_SOURCE, SET_BEARER_TYPE } from "../../../Redux/PolicyNumber/types";

const CustomCardHeading = styled.div`
  font-size: 24px;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const TeleMedicalBookingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isExternalSource, setIsExternalSource] = useState(false);
  const {
    policyNum,
    applicationID,
    policyStatus,
    product,
    channel,
    agent,
    premium,
    branchMaster,
    zone,
    inwardTypeCode,
    hniFlag,
    proposerFirstName,
    portability,
    bearerObj
  } = PolicyDetails();
  
  const { AppointmentBookings, isLoaded } = TeleAppointmentDetails();

  const byPassApiCall = async (policyNum, sourceType) => {
    dispatch({type: SET_TELE_APPOINTMENT_LOADED, payload: false})
    try {
      const payload = {
        policyNum: null,
        applicationID: policyNum,
        source: sourceType
      }
      const bearerTn = await getAccTn();
      const encodedPayload = encrypt(JSON.stringify(payload))
      const result = await postApi(GET_PPMC_DETAILS, {
        encodedString: encodedPayload,
      },{ headers: {'Authorization': `Bearer ${bearerTn}`} });
      if (result?.data?.response) {
        //DISPATCH POLICY DETAILS
        const decryptResponse = JSON?.parse(decrypt(result?.data?.response));
        dispatch(getPolicyDetails(decryptResponse));
        getBookingDetails(decryptResponse?.policyNum);
      }
      else if(result?.data?.errorMessage){
        dispatch({type: SET_TELE_APPOINTMENT_LOADED, payload: true})
        message?.error(result?.data?.errorMessage)
      }
    } 
    catch (error) {
      dispatch({type: SET_TELE_APPOINTMENT_LOADED, payload: true})
      console.error(error);
    }
  };

  const refresh = async () => {
    if (bearerObj) {
      const obj = JSON?.parse(decrypt(bearerObj));
      const access = obj?.access;
      try {
        const response = await postApi(JWT_REFRESH, "", {
          headers: { Authorization: `Bearer ${access}` },
        });
        const decryptResponse = JSON?.parse(decrypt(response?.data));
        const obj = {
          access: decryptResponse?.access_token,
          time: getTokenTimestamp(),
          refresh: decryptResponse?.refresh_token,
        };
        const eto = encrypt(JSON.stringify(obj));
        dispatch({ type: SET_BEARER_TYPE, payload: eto });
        return decryptResponse?.access_token;
      } catch (error) {
        console.error("t refresh failed", error);
      }
    }
  };
  const getAccTn = async () => {
    if (bearerObj) {
      const obj = JSON?.parse(decrypt(bearerObj));
      const time = obj?.time;
      const access = obj?.access;
      const currentTime = moment().unix() * 1000; // Current time in milliseconds
      const threshold = 10;
      const minutesBeforeExpiration = time - threshold * 60 * 1000; // threshold minutes to ms
      if (currentTime >= minutesBeforeExpiration) {
        // Trigger t generate if the t is expired
        if (currentTime >= time) {
          const newFetchedTn = await generateTn();
          return newFetchedTn;
        } // Trigger t refresh if the t is about to expire
        else {
          const newTn = await refresh();
          return newTn;
        }
      } else {
        return access;
      }
    } //Generate access t
    else {
      const newTn = await generateTn();
      return newTn;
    }
  };
  const generateTn = async () => {
    try {
      const payload = {
        username: "Administrator",
        password: process.env.REACT_APP_TOKEN_PASSWORD,
      };
      const encodedPayload = encrypt(JSON.stringify(payload));
      const result = await postApi(JWT_LOGIN, {
        encodedString: encodedPayload,
      });
      const decryptResponse = JSON?.parse(decrypt(result?.data));
      if (decryptResponse?.access_token) {
        const obj = {
          access: decryptResponse?.access_token,
          time: getTokenTimestamp(),
          refresh: decryptResponse?.refresh_token,
        };
        const eto = encrypt(JSON.stringify(obj));
        dispatch({ type: SET_BEARER_TYPE, payload: eto });
        return decryptResponse?.access_token;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const checkDefaultParams = () => {
    const query = getURlParameter("q");
    const getSource = (type) => {
      if(type === "buyOnline"){
        return "BOL";
      }
      else if(type === "sellOnline"){
        return "SOL";
      }
      else {
        return type;
      }
    }
    if (query) {
      // setIsExternalSource(true);
      // const decryptText = decrypt(query);
      // const parsedData = JSON?.parse(decryptText);
      // const appNo = parsedData?.pno;
      // const sourceType = getSource(parsedData?.source);
      // dispatch({
      //   type: SET_APP_SOURCE,
      //   payload: {source: sourceType},
      // });
      // byPassApiCall(appNo, sourceType);
    }
    else {
      getBookingDetails();
    }
  }

  const getTpaDetails = async () => {
    try {
      const payload = {
        inwardType: "00",
        product: product,
        channel: channel,
        agent: agent,
        hni: hniFlag || "",
        portability: portability,
        premium: premium,
        zone: zone,
        branchMaster: branchMaster,
        language: null,
        status: policyStatus,
        dateCheck: moment().format(CONSTANTS?.FORMAT_DOB_SLASH),
        applicationNumber: applicationID,
      };
      const encodedPayload = encrypt(JSON.stringify(payload));
      const result = await postApi(GET_TELE_TPA_DETAILS, {
        encodedString: encodedPayload,
      });
      if (result?.data?.response) {
        const decryptedResponse = JSON?.parse(decrypt(result?.data?.response))
        dispatch(setTpaDetails({ value: decryptedResponse?.tpa }));
      }
    } catch (error) {
      message.error(error_message?.common_error);
      console.error(error);
    }
  };
  const getBookingDetails = async (pno = policyNum) => {
    try {
      const encryptedNumber = encrypt(pno?.trim());
      const url = `${GET_TELE_BOOKING_DETAILS}?applicationNumber=${encodeURIComponent(encryptedNumber)}`;
      const result = await getApi(url);
      if(result?.data?.response){
        const decryptedResponse = JSON?.parse(decrypt(result?.data?.response));
        dispatch(setAppointmentDetails({
          Application_Number: decryptedResponse?.Application_Number,
          Insured_Info: decryptedResponse?.Insured_Info,
         }));
      }
      else{
        //CALLING TPA DETAILS
        getTpaDetails();
      }
      dispatch({type: SET_TELE_APPOINTMENT_LOADED, payload: true})
    } catch (error) {
      //CALLING TPA DETAILS
      getTpaDetails();
      dispatch({type: SET_TELE_APPOINTMENT_LOADED, payload: true})
      console.error(error);
      message.error(error?.errorMessage);
    }
  };

  useEffect(() => {
    dispatch(resetBookMemberDetails());
    scrollToTop();
    checkDefaultParams();
    return () => {
      dispatch(resetBookMemberDetails());
    }
  }, []);

  return (
    <>
      <section>
        {!isExternalSource && <div
          className="arrow-back"
          style={{ padding: "10px", marginTop: "12px" }}
        >
          <div className="arrow-back-container">
            <img
              src={arrowBackIcon}
              alt="back"
              onClick={() => navigate(-1)}
              style={{ marginRight: "10px", cursor: "pointer" }}
            />
            <CustomLabel font_size="14" font_weight="bold">
              {PAGE_CONSTANTS?.APPLICATION_TRACKER}
            </CustomLabel>
          </div>
        </div>}
        <div className={`container ${isExternalSource && 'pt-head'}`}>
          <Wrapper style={{ width: "100%", margin: "auto" }}>
            <Row>
              <Col lg={24} md={24}>
                <CustomCardHeading style={{ marginBottom: "33px" }}>
                  {PAGE_CONSTANTS?.TELE_MEDICAL_BOOKING}
                </CustomCardHeading>
              </Col>
            </Row>
            {isLoaded && policyNum ? (
              <TeleDetails
                bookedAppointment={AppointmentBookings}
                isLoaded={isLoaded}
                proposerFirstName={proposerFirstName}
              />
            ) : null}
          </Wrapper>
        </div>
      </section>
    </>
  );
};

export default TeleMedicalBookingPage;
